import { Select } from 'bold-ui'
import { DEFAULT_SELECT_SIZE } from 'components/form/field/select/useAsyncQuerySelect'
import { usePeriodoOdontogramaSelectQuery } from 'graphql/hooks.generated'
import { PeriodoOdontogramaSelectQuery } from 'graphql/types.generated'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

export interface PeriodoOdontogramaSelectModel {
  odontogramaId: ID
  atendimentoId: ID
  dataIniciado: Date
  label: string
}

export interface PeriodoOdontogramaSelectProps {
  prontuarioId: ID
  onChange(item: PeriodoOdontogramaSelectModel): void
}

const initialItem = {
  odontogramaId: null,
  label: 'Atual',
} as PeriodoOdontogramaSelectModel

export const PeriodoOdontogramaSelect = (props: PeriodoOdontogramaSelectProps) => {
  const { prontuarioId, onChange } = props
  const [value, setValue] = useState<PeriodoOdontogramaSelectModel>(initialItem)
  const [items, setItems] = useState<PeriodoOdontogramaSelectModel[]>([initialItem])

  const {
    data: { odontogramas },
  } = usePeriodoOdontogramaSelectQuery({
    variables: {
      input: {
        prontuarioId: prontuarioId,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
        },
      },
    },
  })

  const handleChange = (item: PeriodoOdontogramaSelectModel) => {
    setValue(item)
    onChange(item)
  }

  useEffect(() => {
    setItems(convertOdontogramasInputToPeriodoModel(odontogramas?.content))
  }, [odontogramas])

  return (
    <Select<PeriodoOdontogramaSelectModel>
      label='Período'
      clearable={false}
      items={items}
      itemToString={(item) => item?.label}
      value={value}
      onChange={handleChange}
    />
  )
}

function convertOdontogramasInputToPeriodoModel(
  odontogramas: PeriodoOdontogramaSelectQuery['odontogramas']['content']
) {
  const items =
    odontogramas?.map(
      (odontograma) =>
        odontograma.id &&
        ({
          odontogramaId: odontograma.id,
          atendimentoId: odontograma.atendProfOdonto.id,
          dataIniciado: odontograma.atendProfOdonto.atendimentoProfissional.iniciadoEm,
          label: `${moment(odontograma.atendProfOdonto.atendimentoProfissional.finalizadoEm).format('DD/MM/YYYY')}`,
        } as PeriodoOdontogramaSelectModel)
    ) || []

  items.unshift(initialItem)
  return items
}
